import { clsx } from 'clsx';
import { ComponentProps, FC } from 'react';

import { Icon } from '@/general/Icons/Icon';
import type { IconName } from '@/general/Icons/sprite.generated';

import { Button } from './Button';

type Props = Prettify<
  Omit<
    ComponentProps<typeof Button>,
    'children' | 'styling' | ' startIcon' | 'endIcon' | 'title' | 'fullWidth' | 'ref'
  > & {
    styling?: 'square' | 'round';
    variant?: 'accent' | 'primary' | 'secondary' | 'tertiary';
    iconName: IconName;
    /** Title of the button, used for accessibility purposes */
    title: string;
  }
>;

export const ButtonIcon: FC<Props> = ({ iconName, styling = 'square', className, ...props }) => (
  <Button {...(props as any)} className={clsx(className, 'button--buttonIcon', `button--${styling}`)}>
    <Icon name={iconName} />
  </Button>
);
